module.exports = __webpack_public_path__ + "img/xuqiu1.b4b466db.webp";